// jsaForm/v2/hazards.actions.js

export const makeJsaV2HazardsActions = ({ setJsaUi, bump, emitJsaPatch }) => ({
  updateJsaV2Hazards(jsaData, hazardsType, value, otherCheckbox = false, emitPatch) {
    jsaData.jsaHazardsV2.updateAttribute(hazardsType, value);
    if (emitPatch) {
      const patch = jsaData.jsaHazardsV2.toPatch({ [hazardsType]: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }

    if (otherCheckbox && value) {
      setJsaUi({
        v2: (prev) => ({
          ...prev,
          hazards: { ...(prev?.hazards || {}), showOtherHazDescribe: true },
        }),
      });
    } else if (!otherCheckbox && !value) {
      setJsaUi({
        v2: (prev) => ({
          ...prev,
          hazards: { ...(prev?.hazards || {}), showOtherHazDescribe: false },
        }),
      });
    }
    bump();
  },

  updateJsaV2HazardsOtherDescribe(jsaData, value, emitPatch) {
    jsaData.jsaHazardsV2.updateOtherDescribe(value);
    if (emitPatch) {
      const patch = jsaData.jsaHazardsV2.toPatch({ otherDescribe: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
});
